module.exports = __webpack_public_path__ + "static/media/United_logo 2_blue.e8acc677.png";